import { proxy } from 'valtio'
import { CommonApi, Option, RankedUniversityOption, RankedUniversityOptionYearTypeEnum } from '../../generated'
import { apiConfig } from '../apiConfig'

export const rankedUniversitiesStore = proxy<{ items: RankedUniversityOption[] }>({
  items: [],
})

const api = new CommonApi(apiConfig)

export async function loadUniversities() {
  await api.getRankedUniversities().then((result) => {
    rankedUniversitiesStore.items = result
  })
}

export function getUniversityOptions(universities: RankedUniversityOption[], country?: Option) {
  const filtered = universities.filter((u) => { return (u.countryId === country?.id || u.isOther) })
  const origins = sortUniversities(filtered)
  const options = sortUniversities(filtered.filter((u) => u.yearType === RankedUniversityOptionYearTypeEnum._2026))
  return { origins, options }
}

function sortUniversities(universities: RankedUniversityOption[]): Option[] {
  return universities
    .map((u) => ({
      label: u.name,
      id: u.id,
      code: u.id.toString(),
      name: u.name,
      nameJa: u.name,
      isOther: u.isOther,
      hidden: false,
    }))
    .sort((a, b) => {
      if (a.isOther) {
        return -1
      }
      if (b.isOther) {
        return 1
      }

      if (a.name < b.name) {
        return -1
      } else if (a.name === b.name) {
        return 0
      } else {
        return 1
      }
    })
}
